import { Column, Row } from 'src/shared/components/Semantic/all'
import { Card } from 'src/shared/components/ui/card'
import { RolePageData } from '../../types'

interface PainPointsSectionProps {
  data: RolePageData
}

export const PainPointsSection = ({ data }: PainPointsSectionProps) => {
  return (
    <section className="w-full py-24 bg-gradient-to-b from-white via-stone-50 to-stone-100">
      <Column className="w-full max-w-6xl mx-auto px-8 gap-12">
        {/* Header */}
        <Column className="gap-4 text-center">
          <h2 className="text-3xl font-normal text-slate-800">
            The challenges you face every day
          </h2>
          <p className="text-slate-500 text-lg max-w-xl mx-auto">
            We continuously hear these frustrations from {data.label.toLowerCase()} teams.
          </p>
        </Column>

        {/* Pain point cards */}
        <Row className="gap-6 flex-wrap">
          {data.painPoints.map((pain) => (
            <Card
              key={pain.title}
              className="flex-1 min-w-[280px] p-6 rounded-2xl bg-white/70 backdrop-blur-sm border border-white/60"
            >
              <Column className="gap-4">
                <div className="w-12 h-12 rounded-full bg-slate-100/80 flex items-center justify-center">
                  <pain.icon
                    className="w-6 h-6 text-slate-500"
                    strokeWidth={1.5}
                  />
                </div>

                <Column className="gap-2">
                  <h3 className="text-lg text-slate-800">
                    {pain.title}
                  </h3>
                  <p className="text-slate-500 text-sm leading-relaxed">
                    {pain.description}
                  </p>
                </Column>
              </Column>
            </Card>
          ))}
        </Row>

        {/* Hidden fears callout */}
        {data.hiddenFears.length > 0 && (
          <Column className="gap-4 p-8 bg-stone-50 rounded-2xl border border-white/60">
            <p className="text-sm font-medium text-slate-500 uppercase tracking-wider text-center">
              The worries you might not say out loud
            </p>
            <Row className="gap-6 justify-center flex-wrap">
              {data.hiddenFears.map((fear, index) => (
                <p key={index} className="text-slate-600 italic">
                  "{fear}"
                </p>
              ))}
            </Row>
          </Column>
        )}
      </Column>
    </section>
  )
}
